<canvas #cvs style="width:100%; height:100%; pointer-events : none;"></canvas>
<div class="polar-btn" (touchstart)="touchStart()" (touchend)="touchEnd()" *ngIf="btnShow">비교</div>
